<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 5080 5080"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_527791824">
   <rect class="fil0" width="5080" height="5080" />
    <path class="fil1"
          d="M3885 2130l-38 0 0 -562c0,-730 -582,-1285 -1307,-1285 -713,0 -1307,620 -1307,1367l480 0c0,-587 288,-939 827,-939 557,0 827,294 827,857l0 562 -2204 0c-313,0 -517,224 -517,537l0 27 0 1541 0 27c0,313 204,535 517,535l2722 0c313,0 549,-222 549,-535l0 -27 0 -1541 0 -27c0,-313 -236,-537 -549,-537zm-1211 1897l0 0c0,88 -72,160 -160,160 -89,0 -161,-72 -161,-160l0 -1174c0,-88 72,-160 161,-160 88,0 160,72 160,160l0 1174z" />
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: "AlarmZone",
};
</script>

<style scoped>
.fil0 {
  fill: none
}

.fil1 {
  fill: #1DAAE1;
  fill-rule: nonzero
}
</style>
